module.exports = __webpack_public_path__ + "static/img/4.34aff25.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/4.jpg
// module id = yFy8
// module chunks = 1